module.exports = __webpack_public_path__ + "assets/698f7803fb0dfe56bac656737a759001.png";